import { JobQueueEntityModel } from "src/store/models/entity/jobQueue/entity";
import { JobQueueHelperModel } from "src/store/models/entity/jobQueue/helper";

export const encooJobQueueModels = {
  entity: JobQueueEntityModel,
  helper: JobQueueHelperModel,
};
